export default __webpack_public_path__ + "static/media/digital_accounts.abedf4b0.pdf";